<style lang="scss" scoped="">
  .el-form .el-select {
    display: block;
  }
</style>
<template>
  <div>
    <h2 class="clearfix">{{form.id ? '编辑' : '添加'}}</h2>
    <el-form :model="form" :rules="rules" @submit.prevent="onSubmit('accountform')" label-width="110px"
             onsubmit="return false" ref="accountform">
      <!--      <el-form-item label="所属单位" prop="logisticsCompanyId">-->
      <!--        <el-select :clearable="true" :remote-method="queryUpOrgList" @click.native.once="queryUpOrgList('')" filterable-->
      <!--                   placeholder="请输入名称/拼音首字母缩写/系统代码搜索所属单位" popperClass="good-selects"-->
      <!--                   remote v-model="form.logisticsCompanyId">-->
      <!--          <el-option :key="org.id" :label="org.name" :value="org.id" v-for="org in upOrgList">-->
      <!--            <div style="overflow: hidden">-->
      <!--              <span class="pull-left" style="clear: right">{{org.name}}</span>-->
      <!--            </div>-->
      <!--            <div style="overflow: hidden">-->
      <!--                      <span class="select-other-info pull-left" v-show="org.manufacturerCode">-->
      <!--                        <span>系统代码:</span>{{org.manufacturerCode}}-->
      <!--                      </span>-->
      <!--            </div>-->
      <!--          </el-option>-->
      <!--        </el-select>-->
      <!--      </el-form-item>-->
      <el-form-item label="物流中心名称" prop="name">
        <el-input placeholder="请输入物流中心名称" v-model="form.name" :maxlength="50" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="物流中心编码" prop="code">
        <el-input placeholder="请输入物流中心编码" v-model="form.code" :maxlength="50" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="物流中心地址" prop="logisticsDetail">
        <el-input placeholder="请输入物流中心地址" v-model="form.logisticsDetail" :maxlength="500" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label-width="100px">
        <el-button :disabled="doing" @click="onSubmit('accountform')" native-type="submit" type="primary">保存</el-button>
        <el-button @click="doClose">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import {BspLogistics} from '@/resources';
  import MethodsMix from '@/mixins/methodsMinix';

  export default {
    name: 'editForm',
    mixins: [MethodsMix],
    props: {
      formItem: {
        type: Object,
        required: true
      },
      show: {
        type: Boolean,
        default: true
      }
    },
    data: function () {
      return {
        form: {
          logisticsCompanyId: this.$store.state.user.userCompanyAddress,
          name: '',
          code: '',
          logisticsDetail: ''
        },
        rules: {
          name: [
            {required: true, message: '请输入物流中心名称', trigger: 'blur'}
          ],
          code: [
            {required: true, message: '请输入物流中心编码', trigger: 'blur'}
          ],
          logisticsDetail: [
            {required: true, message: '请输入物流中心地址', trigger: 'blur'}
          ]
        },
        doing: false,
        logisticsCenter: [],
        keyList: []
      };
    },
    watch: {
      formItem: function (val) {
        this.keyList = [];
        this.$refs['accountform'].clearValidate();
        this.upOrgList = [];
        if (val.id) {
          this.upOrgList = [{id: this.formItem.logisticsCompanyId, name: this.formItem.logisticsCompanyName}];
          this.form = Object.assign({}, this.formItem);
        } else {
          this.form = {
            logisticsCompanyId: this.$store.state.user.userCompanyAddress,
            name: '',
            code: '',
            logisticsDetail: ''
          };
        }
      },
      show: function (val) {
        if (!val) {
          this.$refs['accountform'].resetFields();
        }
      }
    },
    methods: {
      onSubmit: function (formName) {
        this.$refs[formName].validate((valid) => {
          if (!valid || this.doing) {
            return false;
          }
          this.doing = true;
          if (!this.form.id) {
            BspLogistics.save(this.form).then(() => {
              this.doing = false;
              this.$notify.success({
                duration: 2000,
                name: '成功',
                message: '新增成功'
              });
              this.$emit('change');
            }).catch(error => {
              this.$notify.error({
                duration: 2000,
                message: error.response.data && error.response.data.msg || '新增失败'
              });
              this.doing = false;
            });
          } else {
            BspLogistics.update(this.form).then(() => {
              this.doing = false;
              this.$notify.success({
                duration: 2000,
                name: '成功',
                message: '修改成功'
              });
              this.$emit('change');
            }).catch(error => {
              this.$notify.error({
                duration: 2000,
                message: error.response.data && error.response.data.msg || '修改失败'
              });
              this.doing = false;
            });
          }
        });
      },
      doClose: function () {
        this.$emit('close');
      }
    }
  };
</script>
